module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker41-api.relevant-digital.com/"}};